import { createUseStyles } from "react-jss";
import {breakpoints} from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";

const styles = createUseStyles({
  peopleFilters: {
    display: "flex",
    width: "100%",
      [`@media (max-width: ${breakpoints.md}px)`]: {
        flexDirection: "column",
      }
  },
  roles: {
    display:"flex",
    alignItems:"center",
    height:"40px",
    margin: "2px 0 0 12px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "16px 0",
      textAlign: "center",
    },
  },
  headerSk1: {
    width: "120px",
    height: "40px",
    margin: "2px 0 0 12px",
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "100%",
      margin: "16px 0",
      height: "40px",
    }
  },
});

export const rolesSelect = theme => ({
  menu: base => ({
    ...base,
    // override border radius to match the box
    borderRadius: "8px",
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    right:"0px",
    border: `1px solid ${colors.lightGrey}`,
    // kill the gap
    marginTop: "8px",
    width:"240px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width:"100%",
    }
  }),
  option: (base, state) =>({
    ...base,
    'img': {
      display: state.isSelected ? 'inline' : 'none',
      float: "right",
      marginTop: "2px"
    },
    backgroundColor: state.isSelected ? colors.brightBlue : colors.white,
    borderRadius: "6px",
    color: colors.lightBlack,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: state.isSelected ? "8px 12px 8px 12px" : "8px 33px 8px 12px",
    },
    "&:hover": {
      backgroundColor: colors.brightBlue
    },
    "&.disabled": {
      background: colors.lightGrey
    },
  }),
  control: (base, {selectProps})  => ({
    ...base,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width:"100%",
    },
    borderRadius: "8px",
    borderColor: theme.field.borderColor,
    padding: "9px 16px",
    fontfamily:"Inter",
    fontSize: "14px",
    fontWeight:"600",
    lineHeight:"20px",
    color:colors.grey,
    margin:"0px",
    boxShadow: "none",
    backgroundColor: selectProps.menuIsOpen ? colors.brightBlue : colors.white,
    border: selectProps.menuIsOpen && "none",
    '&:active &:focus': {
      borderRadius: "8px",
      borderColor: theme.field.borderColorFocus,
      boxShadow: "none"
    },
    '&:hover': {
      borderColor: theme.field.borderColorHover
    }
  }),
  valueContainer: base => ({
    ...base,
    padding: "0px",
  }),
  singleValue: base => ({
    ...base,
    marginLeft:"0px",
    marginRight:"8px",
    padding: "0px",
    color: colors.grey
  }),

  menuList: base => ({
    ...base,
    fontfamily:"Inter",
    fontSize: "14px",
    fontWeight:"500",
    lineHeight:"20px",
    color:colors.grey,
    padding: '8px'
  }),

  dropdownIndicator: (base, { selectProps })  => ({
    ...base,
    padding: "0px",
    color:colors.mediumGrey,
    transition: selectProps.menuIsOpen ? 'all .2s ease' : 'none',
    transform: selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
    '&:hover': {
      color: `${colors.mediumGrey} !important`,
    }
  }),
});

export default styles;
